import React, { Component } from 'react';
import classNames from 'classnames';
import Clamp from 'shiitake';
import { toList } from 'utils/string_utils';
import { Icon } from 'ui';
import BootstrapTooltip from './BootstrapTooltip';

class ContentItemCard extends Component {
  constructor() {
    super();
    this.state = { tagsVisible: false };
    this.handleTagsPillClick = this.handleTagsPillClick.bind(this);
    this.toggleTagsVisibility = this.toggleTagsVisibility.bind(this);
    this.setTagsPopoverWidth = this.setTagsPopoverWidth.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  toggleTagsVisibility() {
    this.setState(state => ({ tagsVisible: !state.tagsVisible }));
  }

  handleTagsPillClick(e) {
    // eslint-disable-line
    e.stopPropagation();
  }

  setTagsPopoverWidth(node) {
    if (this.props.layout !== 'list') return;
    if (node && this.tagsPill) {
      const ownRight = parseInt(getComputedStyle(node).right, 10);
      const pillWidth = this.tagsPill.getBoundingClientRect().width;
      node.style.right = `${ownRight + pillWidth + 14}px`;
      node.style.maxWidth = `calc(100% - ${ownRight + pillWidth + 24}px)`;
    }
  }

  handleClick() {
    if (this.props.onClick && !this.props.invalid) {
      this.props.onClick(this.props.id);
    }
  }

  get tagsLabel() {
    const { tags } = this.props;
    return tags.length === 1 ? tags[0].name : `${tags.length} Tags`;
  }

  render() {
    const {
      title,
      iconName,
      onClick,
      count,
      countLabel,
      tags,
      layout,
      active,
      clamp,
      infoTooltip,
      invalidTooltip,
      showCount,
      invalid,
    } = this.props;
    const showTagsTooltip = tags.length >= 2;

    const contentItemClassName = classNames('ContentItem', {
      'ContentItem--card': layout === 'card',
      'ContentItem--list': layout === 'list',
      'ContentItem--active': active,
      'ContentItem--clickable': !!onClick && !invalid,
      'ContentItem--disabled': invalid,
    });

    const tagsPillClassName = classNames('ContentItem-tagsPill', {
      'Pill Pill--gray tt-u Pill--small': true,
      'ContentItem-tagsPill--withTooltip': showTagsTooltip,
    });

    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <div onClick={this.handleClick} className={contentItemClassName}>
        <div className="ContentItem-info">
          {iconName && (
            <Icon name={iconName} className="ContentItem-icon midnight-100" />
          )}
          <Clamp
            className="ContentItem-title ws-pr"
            lines={clamp[layout].title}
            children={title}
          />
        </div>
        {/* TODO replace this with shiitake when adding tags */}
        {showTagsTooltip && this.state.tagsVisible && (
          <div
            ref={this.setTagsPopoverWidth}
            className="ContentItem-tagsPopover"
          >
            <Clamp lines={clamp[layout].tags} tagName="span">
              {toList(
                tags.map(t => t.name),
                true,
              )}
            </Clamp>
          </div>
        )}
        <div className="ContentItem-meta">
          {(showCount || !!count) && (
            <div>
              <span className="ContentItem-count">
                {count} {countLabel}
              </span>
              {invalid && (
                <BootstrapTooltip
                  className="ml-4"
                  tooltip={invalidTooltip}
                  dataPlacement="top"
                  iconName="warning_sign"
                  iconClasses="c-brand-red"
                />
              )}
              {infoTooltip && !invalid && (
                <BootstrapTooltip
                  className="ml-4"
                  tooltip={infoTooltip}
                  dataPlacement="top"
                  iconName="info"
                  iconClasses="ContentItem--hoverColorStyles midnight-70"
                />
              )}
            </div>
          )}
          {!!tags.length && (
            <button
              type="button"
              className={tagsPillClassName}
              onMouseEnter={this.toggleTagsVisibility}
              onMouseLeave={this.toggleTagsVisibility}
              onClick={this.handleTagsPillClick}
              children={this.tagsLabel}
              ref={n => {
                if (n) {
                  this.tagsPill = n;
                }
              }}
            />
          )}
        </div>
      </div>
    );
  }
}

ContentItemCard.defaultProps = {
  tags: [],
  layout: 'card',
  clamp: {
    list: {
      tags: 2,
      title: 1,
    },
    card: {
      tags: 3,
      title: 2,
    },
  },
};

export default ContentItemCard;
